import {
  LOAD_PATIENTS,
  LOAD_PATIENT,
  PATIENT_ADD,
  PATIENTS_RESET_LOADING,
  SET_PATIENTS_FILTER,
  PATIENTS_RESET_TO_MODE,
  SET_ACTIVE_PATIENT,
  ADD_TO_FILTER_FROM_DASHBOARD,
  REFRESH_PATIENTS,
  SAVED_SEARCHES_LOADED,
  REJECT_WITHINGS_INTEGRATION,
  LOAD_SAVED_SEARCHES,
  SET_EDIT_PATIENT_CP

} from "./actionTypes";

export function onLoadPatient(id) {
  return { type: LOAD_PATIENT, id };
}

export function onLoadPatients(searchCriteria) {
  return { type: LOAD_PATIENTS, searchCriteria };
}

export function onAddPatient(data) {
  return { type: PATIENT_ADD, data: data };
}

export function onResetLoading() {
  return { type: PATIENTS_RESET_LOADING };
}

export function onResetToMode(mode) {
  return { type: PATIENTS_RESET_TO_MODE, mode };
}

export function onSetFilter(filter, mode, staffId) {
  return { type: SET_PATIENTS_FILTER, filter, mode, staffId };
}

export function onSetActivePatient(patientId) {
  return { type: SET_ACTIVE_PATIENT, patientId };
}

export function onAddToPatientFilter(fields) {
  return { type: ADD_TO_FILTER_FROM_DASHBOARD, fields };
}

export function refreshListing() {
  return { type: REFRESH_PATIENTS };
}

export function onLoadSavedSearches() {
  return { type: LOAD_SAVED_SEARCHES };
}

export function setEditPatientCarePlan(data) {
  return { type: SET_EDIT_PATIENT_CP, data };
}

